import React from 'react';

export interface Disables{
    app: boolean;
    user: boolean;
    session: boolean;
    timeout: boolean;
    token: boolean;
    keep: boolean;
    connect: boolean;
    disconnect: boolean;
    userSwitching: boolean;
    tokenForUpdate: boolean;
    userLog: boolean;
    pub: boolean;
    sub: boolean;
    recv: boolean;
}

export const beforeConnecting: Disables = {
    app: false,
    user: false,
    session: false,
    timeout: false,
    token: false,
    keep: false,
    connect: false,
    disconnect: true,
    userSwitching: false,
    tokenForUpdate: true,
    userLog: false,
    pub: true,
    sub: true,
    recv: true
}

export const onClick: Disables = {
    app: false,
    user: false,
    session: false,
    timeout: false,
    token: false,
    keep: false,
    connect: true,
    disconnect: false,
    userSwitching: true,
    tokenForUpdate: true,
    userLog: false,
    pub: true,
    sub: true,
    recv: true
}

export const connecting: Disables = {
    app: true,
    user: true,
    session: true,
    timeout: true,
    token: true,
    keep: true,
    connect: true,
    disconnect: false,
    userSwitching: true,
    tokenForUpdate: false,
    userLog: false,
    pub: false,
    sub: false,
    recv: false
}

export const disconnecting: Disables = {
    app: true,
    user: true,
    session: true,
    timeout: false,
    token: false,
    keep: false,
    connect: false,
    disconnect: true,
    userSwitching: false,
    tokenForUpdate: true,
    userLog: false,
    pub: false,
    sub: true,
    recv: true
}

export const DisablesContext = React.createContext(beforeConnecting);
export const SetDisablesContext = React.createContext<React.Dispatch<React.SetStateAction<Disables>>>(() => {});
